import { defineStore } from "pinia";
import { FetchService } from "@/services/fetch.service";
import { useAuthenticationStore } from "./authentication";
import type { GetSchoolDetails } from "@/api_types/school";
import { useSchoolStore } from "./school";

export const useDistrictStore = defineStore("district", {
  state: () => {
    return {
      account: "",
      schools: [] as GetSchoolDetails[]
    };
  },

  actions: {
    async fetchSchools(): Promise<GetSchoolDetails[]> {
      const authStore = useAuthenticationStore();
      const schoolStore = useSchoolStore();
      
      if (
        (schoolStore.school?.is_district == "yes" || schoolStore.school?.is_district == true) &&
        authStore.jwtData?.authentication_type === "district"
      ) {
        console.log("Fetching schools for district inside the store");
        const res =
          (await FetchService.fetchData("/schools", "get"))?.filter?.(
            (i) => i.school_id !== schoolStore.school?.school_id
          ) || [];
        console.log(res);
        this.schools = res;
        return res;
      }
      
      this.schools = [];
      return [];
    }
  }
});